import { useState, useEffect } from "react"

const useLocalStorage = (key, initialState) => {
	const [state, setState] = useState(
		() => {
			const value = window.localStorage.getItem(key)
			if (typeof value !== "undefined" && value !== null) {
				if (value === "true") return true
				if (value === "false") return false
				return value
			} else {
				return initialState
			}
		}
	)

	useEffect(() => {
		window.localStorage.setItem(key, JSON.stringify(state));
	}, [key, state])

	return [state, setState]
}

export default useLocalStorage